import { classNames } from 'primereact/utils';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateDienstleistungPreisMutation, useDeleteDienstleistungPreisMutation, useGetDienstleistungListeMutation, useGetDienstleistungPreisMutation } from '../../../api/StammdatenAPI';
import { IAuftraggeber, IDienstleistung, IDienstleistungPreisRequest } from '../../../types/Types';
import { formatToStringISODate } from '../../../util/DateUtils';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { useGetAuftraggeberListeMutation } from '../../../api/OfficeAPI';

const emptyIDienstleistungPreisDto: IDienstleistungPreisRequest = {
  uid: '',
  preis: 0,
  gueltigAb: new Date(),
  uid_auftraggeber: '',
  uid_dienstleistung: ''
}

export default function PreiseDetail() {
  const { t } = useTranslation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IDienstleistungPreisRequest>(emptyIDienstleistungPreisDto);

  const [moegAuftraggeber, setMoegAuftraggeber] = useState<IAuftraggeber[]>([]);
  const [getAuftraggeberApi] = useGetAuftraggeberListeMutation();

  const [moegDienstleistungen, setMoegDienstleistungen] = useState<IDienstleistung[]>([]);
  const [getDienstleistungenApi] = useGetDienstleistungListeMutation();

  const [getSatzApi] = useGetDienstleistungPreisMutation();

  const [deleteApi] = useDeleteDienstleistungPreisMutation();
  const [createOrUpdateAPI] = useCreateOrUpdateDienstleistungPreisMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const init = () => {

    getAuftraggeberApi().unwrap()
      .then(data => setMoegAuftraggeber(data))
      .catch((e) => console.log(e));

    getDienstleistungenApi().unwrap()
      .then(data => setMoegDienstleistungen(data))
      .catch((e) => console.log(e));

    if (location.state.view === 'detail') {
      getSatzApi(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten({
            uid: e.uid,
            preis: e.preis,
            gueltigAb: new Date(e.gueltigAb),
            uid_auftraggeber: e.auftraggeber.uid,
            uid_dienstleistung: e.dienstleistung.uid
          });
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyIDienstleistungPreisDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteApi(daten!.uid).unwrap()
        .then(() => navigate('/admin/preise/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (daten.uid_auftraggeber === "") {
      window.alert("Bitte einen Auftraggeber auswählen!");
      return;
    }
    
    if (daten.uid_dienstleistung === "") {
      window.alert("Bitte eine Dienstleistung auswählen!");
      return;
    }

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateAPI(daten)
          .then( () => navigate('/admin/preise/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateAPI(daten)
          .then( () => navigate('/admin/preise/'))
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changedate = (e: ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Preise Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >
            {(isLoaded && daten !== undefined &&
              <>
                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Auftraggeber</label>
                    <select name="uid_auftraggeber" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.uid_auftraggeber}>
                      <option value={""}>-- Bitte auswählen --</option>
                      {moegAuftraggeber.map((e, index) =>
                        <option key={index} value={e.uid} selected={daten.uid_auftraggeber === e.uid ? true : false}>{e.name}</option>)
                      }
                    </select>
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Dienstleistung</label>
                    <select name="uid_dienstleistung" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.uid_dienstleistung}>
                      <option value={""}>-- Bitte auswählen --</option>
                      {moegDienstleistungen.map((e, index) =>
                        <option key={index} value={e.uid} selected={daten.uid_dienstleistung === e.uid ? true : false}>{e.text}</option>)
                      }
                    </select>
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Preis</label>
                    <input type="text" className={styles['wg-input-text']} name="preis" value={daten?.preis} onChange={changeit} />
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Preis</label>
                    <input type="date" className={styles['wg-input-text']} name="gueltigAb" value={formatToStringISODate(daten?.gueltigAb)} onChange={changedate} />
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div></div>
                  <div></div>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                </div>

              </>)}
          </form>


        </div>
      </div>
    </>
  );
}